import { atom, useAtomValue, useSetAtom } from 'jotai';

export const DEFAULT_SCALE_VALUE = 1;

export const scaleAtom = atom(DEFAULT_SCALE_VALUE);

export const useTableScale = () => {
  return useAtomValue(scaleAtom);
};

export const useSetTableScale = () => {
  return useSetAtom(scaleAtom);
};
